import React, {useEffect} from 'react';
import {View, Share, StyleSheet} from 'react-native';
import {ActivityIndicator} from 'react-native-paper';
import {useTranslation} from 'react-i18next';
import {useNavigation} from '@react-navigation/native';
import {colors} from '../../theme';

const ShareScreen = () => {
  const {t} = useTranslation();
  const navigation = useNavigation();

  useEffect(() => {
    const doShare = async () => {
      try {
        await Share.share({
          message: t('share.message'),
          title: t('share.title'),
        });
      } catch (_) {
        // User cancelled or error — ignore
      }
      // Navigate back to previous screen after share dialog closes
      if (navigation.canGoBack()) {
        navigation.goBack();
      }
    };
    doShare();
  }, [t, navigation]);

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={colors.primary} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: colors.background},
});

export default ShareScreen;
